const baseImageContent = {
  type: "image",
  inputType: "",
  label: "",
  data: {
    id: "",
    key: "",
    value: "",
    type: "generalSetting",
    file: {},
    isUpdated: false,
  },
  translation: {
    input: "",
    flag: false,
    isUpdated: false,
  },
};

const baseInputContent = {
  type: "input",
  inputType: "text",
  label: "",
  data: {
    id: "",
    key: "",
    value: "",
    type: "generalSetting",
    file: {},
    isUpdated: false,
  },
  translation: {
    input: "",
    flag: false,
    isUpdated: false,
  },
};

const createSettingEntry = (title: string, key: string, contentType: 'image' | 'input', inputType: string = '') => ({
  title,
  content: {
    ...(contentType === 'image' ? baseImageContent : baseInputContent),
    inputType,
    data: {
      ...baseImageContent.data,
      key,
      value: "",
    },
    ...(contentType === 'input' && { inputType }),
  },
  isRequired: false,
  readonly: false,
  isButton: contentType === 'image',
});

const generalSettings = [
  createSettingEntry("Default Profile Picture", "defaultProfilePicture", 'image'),
  createSettingEntry("Power Load Up Bar", "defaultPowerLoadUpBar", 'image'),
  createSettingEntry("Splash Screen Title", "splashScreenTitle", 'input', 'text'),
  createSettingEntry("Users To Appear On Leaderboard", "noOfUsersOnLeaderboard", 'input', 'number'),
];

export { generalSettings };